export default __webpack_public_path__ + "static/media/tree.ab306378.less";